import {Box, Button, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';

import {IconIllustration, Modal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils';
import {Loading} from 'presentation/components/Loading/Loading';
import {ConfirmChangeBankModalProps} from './types';

const {title, subtitle, description} =
	translations['pt-br'].privateFlow.profile.changeData.confirmChangesBankModal;
const {cancel, confirm} = translations['pt-br'].commons;

const ConfirmChangeBankModal = ({
	open,
	setOpen,
	onConfirm,
	data,
	isSubmitting,
}: ConfirmChangeBankModalProps) => {
	const {colors} = useTheme();

	if (!data) return null;

	return (
		<Modal.Root open={open} onClose={() => setOpen(false)}>
			<Modal.Header onClose={() => setOpen(false)} title={title} />

			<Modal.Content>
				<Stack spacing={2} alignItems="center">
					<IconIllustration variant="info" />
					<Typography variant="h6" textAlign="center">
						{subtitle}
					</Typography>
					<Typography textAlign="center" variant="body1">
						{description}
					</Typography>
					<Box borderRadius={1} padding={1.5} bgcolor={colors.gray['10Percent']}>
						<Typography fontWeight={700}>{formatText(data.name)}</Typography>
						<Typography>
							Agência: <strong>{data.agency}</strong> | Conta:{' '}
							<strong>{data.accountWithDigit}</strong>
						</Typography>
					</Box>
				</Stack>
			</Modal.Content>

			<Modal.Footer>
				<Stack width="100%" direction="row" spacing={1}>
					<Button
						fullWidth
						size="large"
						variant="outlined"
						onClick={() => setOpen(false)}>
						{cancel}
					</Button>
					<Button
						disabled={isSubmitting}
						onClick={onConfirm}
						fullWidth
						size="large"
						variant="contained"
						endIcon={isSubmitting ? <Loading size={20} color="inherit" /> : null}>
						{confirm}
					</Button>
				</Stack>
			</Modal.Footer>
		</Modal.Root>
	);
};

export {ConfirmChangeBankModal};
